/**
 * 검토 1단계 「값 존재」 — DSD 표의 숫자 값이 IXD 에서 찾아졌는지 칸 색 기준으로 센다.
 *
 * 칸 색과 같은 기준이다: 초록(일치) · 노랑(부호 반대·단수차) · 빨강(태깅돼야 하는데 IXD 에서
 * 못 찾음). 매칭 후보도 추론 위치도 없는 칸(흰 칸)은 대조 대상이 아니라 세지 않는다.
 * 2단계 「값 위치」 는 찾은 값만 다루므로, 못 찾은 값이 많으면 위치 검토가 그만큼 비어 있다.
 */

import type { DSDSubChunkInfo } from "@/apis/compare/types";
import { DsdCellText } from "@/utils/dsd-cell-text";

export interface ValuePresence {
  /** 초록 — IXD 와 값·부호가 일치 */
  found: number;
  /** 노랑 — 부호가 반대이거나 단수차 */
  nearlyFound: number;
  /** 빨강 — 태깅돼야 하는데 IXD 에서 값을 못 찾음 */
  notFound: number;
}

export const summarizeValuePresence = (
  subChunks: readonly DSDSubChunkInfo[],
): ValuePresence => {
  const presence: ValuePresence = { found: 0, nearlyFound: 0, notFound: 0 };
  for (const subChunk of subChunks)
    for (const block of subChunk.parsedContent ?? []) {
      if (block.blockType !== "table" || !block.cells) continue;
      for (const row of block.cells)
        for (const cell of row) {
          if (!cell?.isOrigin || !DsdCellText.of(cell.text).isNumericValue)
            continue;
          if (cell.matchStatus === "matched") presence.found += 1;
          else if (
            cell.matchStatus === "negated" ||
            cell.matchStatus === "rounded"
          )
            presence.nearlyFound += 1;
          else if (cell.matchStatus === "should-tag") presence.notFound += 1;
        }
    }
  return presence;
};
